import api from 'api';
import type { ExtendedError } from 'factories/api';
import type { AddOnCodes } from 'redux/modules/accounts.schema';
import type { RawAddOn } from 'types/account';
import { forceIntercomPing } from 'utils/intercom-helper';

/**
 * The bank page to send the user to when Rails answers a subscribe with 422 because the card needs
 * 3DS (`redirect_url` beside the message), or null for any other failure.
 */
export const getAddOnBankRedirectUrl = (error: unknown): string | null => {
  const redirectUrl = (error as Partial<ExtendedError> | null)?.response?.redirect_url;
  return typeof redirectUrl === 'string' && redirectUrl ? redirectUrl : null;
};

export const AccountAddOnsAPI = {
  list(): Promise<Array<RawAddOn>> {
    return api.get('subscriptions/add_ons');
  },
  cancel: (code: AddOnCodes): Promise<RawAddOn> => {
    return api.delete('subscriptions/add_ons', { code });
  },
  subscribe: (code: AddOnCodes): Promise<RawAddOn> => {
    return api.post('subscriptions/add_ons', { code });
  },
  trial: (code: string): Promise<RawAddOn> => {
    return api.post('subscriptions/add_ons/trial', { code }).then(res => {
      // Ping intercom after a delay, to ensure the user inherits
      // new trial properties set on the workspace/"company",
      // used to trigger product tours
      forceIntercomPing(5);
      return res;
    });
  },
};
